import { createContext } from 'react';

// Create context with default value to prevent undefined errors
export const AuthContext = createContext(null);
